import mod from "-!./expoolExercise.js?vue&type=script&lang=js&"; export default mod; export * from "-!./expoolExercise.js?vue&type=script&lang=js&"